// School Status Enum
const SchoolStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
};

class School {
  constructor({
    id,
    status,
    appWebUrl,
    name,
    phone,
    schoolCode,
    pricingPlanId = null,
    dataSpreadSheetId = null,
    reportSpreadSheetId = null,
    currentAcademicYear = null,
    iconUrl = null,
    letterHead = null
  }) {
    this.id = id;
    this.status = status;
    this.appWebUrl = appWebUrl;
    this.name = name;
    this.phone = phone;
    this.schoolCode = schoolCode;
    this.pricingPlanId = pricingPlanId;
    this.dataSpreadSheetId = dataSpreadSheetId;
    this.reportSpreadSheetId = reportSpreadSheetId;
    this._enabledFeatures = [];
    this.currentAcademicYear = currentAcademicYear;
    this.iconUrl = iconUrl;
    this.letterHead = letterHead;
  }

  // Getter for enabledFeatures
  get enabledFeatures() {
    return this._enabledFeatures;
  }

  // Setter for enabledFeatures
  set enabledFeatures(value) {
    this._enabledFeatures = value;
  }

  // Factory constructor equivalent - fromMap
  static fromMap(data) {
    const school = new School({
      id: data.id,
      status: School._getSchoolStatus(data.status),
      appWebUrl: data.appWebUrl,
      name: data.name,
      phone: data.phone,
      schoolCode: data.schoolCode,
      pricingPlanId: data.pricingPlanId || null,
      dataSpreadSheetId: data.dataSpreadSheetId || null,
      reportSpreadSheetId: data.reportSpreadSheetId || null,
      currentAcademicYear: data.academicYear || null,
      iconUrl: data.iconUrl || null,
      letterHead: data.letterHead || null
    });
    
    return school;
  }

  // Convert to map/object
  toMap() {
    return {
      id: this.id,
      status: this.status,
      appWebUrl: this.appWebUrl,
      name: this.name,
      phone: this.phone,
      pricingPlanId: this.pricingPlanId,
      schoolCode: this.schoolCode,
      dataSpreadSheetId: this.dataSpreadSheetId,
      reportSpreadSheetId: this.reportSpreadSheetId,
      currentAcademicYear: this.currentAcademicYear,
      iconUrl: this.iconUrl,
      letterHead: this.letterHead
    };
  }

  // Private helper method for getting school status
  static _getSchoolStatus(name) {
    if (!name) {
      return SchoolStatus.ACTIVE;
    } else if (name === SchoolStatus.ACTIVE) {
      return SchoolStatus.ACTIVE;
    } else {
      return SchoolStatus.INACTIVE;
    }
  }
}

export { School, SchoolStatus };
